import React from 'react';

const DemoLogic = () => {
  return <div></div>;
};

export default DemoLogic;
